import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Box,
  Typography,
  IconButton,
  useMediaQuery,
  Popover,
} from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { changeLoading } from "../../slices/userReducer";
import { Tooltip } from "@mui/material";
import TimelineTwoToneIcon from "@mui/icons-material/TimelineTwoTone";
import NorthIcon from "@mui/icons-material/North";
import SouthIcon from "@mui/icons-material/South";
import Modal from "@mui/material/Modal";
import Chart from "../Chart";
import axios from "axios";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import CloseIcon from "@mui/icons-material/Close";

export default function TableResults({
  resultsData = [],
  resultCell,
  currentPage,
  resultsPerPage,
  handlePageChange,
  handleViewResult,
  handleResultsPerPageChange,
  text,
  onClickData,
  searchTerm,
  buttonText,
  onSearchChange,
  isSmallTable,
  filterEGN,
  filterName,
  filterIme,
  setResultsData,
}) {
  const { config } = useSelector((state) => state.user);
  const token = localStorage.getItem("token");
  const isMobile = useMediaQuery("(max-width: 960px)");
  const [localResultsData, setLocalResultsData] = useState(resultsData || []);
  const [openChart, setOpenChart] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedProfilRow, setSelectedProfilRow] = useState(null);
  const [answer, setAnswer] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (resultsData) {
      setLocalResultsData(resultsData);
    }
  }, [resultsData]);
  const currentResults = localResultsData.slice(
    currentPage * resultsPerPage,
    (currentPage + 1) * resultsPerPage
  );
  useEffect(() => {
    // If search term is changed, reset to the first page
    handlePageChange(null, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, filterName, filterIme, filterEGN]);

  const [chartData, setChartData] = useState(null);
  const dispatch = useDispatch();

  const handleChartFetch = async (
    groupIndex,
    resultIndex,
    profilIndex = null
  ) => {
    const uniqueId = `${groupIndex}-${resultIndex}-${profilIndex}`;
    let isSelected = false;

    if (profilIndex === null) {
      //  Handle Result Row Selection
      isSelected =
        selectedRow?.groupIndex === groupIndex &&
        selectedRow?.resultIndex === resultIndex;
      if (isSelected) {
        //  Close already opened result chart
        setSelectedRow(null);
        setSelectedProfilRow(null);
        setChartData(null);
        dispatch(changeLoading(false));
        return;
      }

      setSelectedRow({ groupIndex, resultIndex });
      setSelectedProfilRow(null); //  Close profil selection when opening a result row
    } else {
      //  Handle Profil Row Selection
      // isSelected =
      //   selectedProfilRow?.resultIndex === resultIndex &&
      //   selectedProfilRow?.profilIndex === profilIndex &&
      //   selectedProfilRow?.groupIndex === groupIndex;
      isSelected = selectedProfilRow?.uniqueId === uniqueId;
      if (isSelected) {
        //  Close already opened profil chart
        setSelectedProfilRow(null);
        setSelectedRow(null);
        setChartData(null);
        dispatch(changeLoading(false));
        return;
      }

      setSelectedProfilRow({ resultIndex, profilIndex, groupIndex, uniqueId });
      setSelectedRow(null); // ✅ Close normal result row when opening a profil row
    }

    dispatch(changeLoading(true));

    try {
      const currentGroup = currentResults[groupIndex];
      const currentResult = currentGroup.Result[resultIndex];

      let pac, idTest;

      if (profilIndex !== null) {
        // Fetching for a Profil row
        const profilItem = currentResult.Profil[profilIndex];
        pac = profilItem.Pac;
        idTest = profilItem.IdTest;
      } else {
        // Fetching for a normal Result row
        pac = currentResult.Pac;
        idTest = currentResult.IdTest;
      }

      const requestBody = { IdPacient: pac, IdTest: idTest };

      const response = await axios.post(
        `${config.apiBaseUrl}/GLabResultService/GetReferralCronologyResult`,
        requestBody,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!response.data) {
        throw new Error("Empty response data");
      }

      setChartData(response.data[0]);
    } catch (error) {
      console.error("Error fetching chart data:", error);
    } finally {
      dispatch(changeLoading(false));
    }
  };

  const handlePopoverOpen = (
    event,
    groupIndex,
    resultIndex,
    profilIndex = null
  ) => {
    setAnchorEl(event.currentTarget); // Set the button or icon as the anchor for Popover
    //setOpen(true); // Open the Popover
    setAnswer(null); // Dont show loading text while fetching the answer
    handleAIQuestion(groupIndex, resultIndex, profilIndex); // Fetch the answer after opening the Popover
  };

  const handlePopoverClose = () => {
    setOpen(false); // Close the Popover
    setAnchorEl(null); // Reset the anchor element
  };

  const handleAIQuestion = async (
    groupIndex,
    resultIndex,
    profilIndex = null
  ) => {
    const currentGroup = currentResults[groupIndex];
    const currentResult = currentGroup.Result[resultIndex];
    const currentProfil =
      profilIndex !== null ? currentResult.Profil[profilIndex] : null;

    let question = "";

    if (profilIndex !== null && currentProfil) {
      // Use profile data when profilIndex is provided
      question = `За тест: ${currentProfil.ProfilNameTest}, какво означава получения резултат: ${currentProfil.ProfilResultat}? Моля, отговори на български език и обясни значението на резултата на български.`;
    } else {
      // Use result data when no profilIndex is provided
      question = `За тест: ${currentResult.NameTest}, какво означава получения резултат: ${currentResult.Resultat}? Моля, отговори на български език и обясни значението на резултата на български.`;
    }
    const apiKey = config.ApiKey;
    const messageText =
      "<span style='color: red; font-weight: bold;'>Текущата информация е генерирана посредством AI - ChatGPT ver.gpt-3.5-turbo - Моля да се обърнете към лекуващият ви лекар за насоки в лечението ви!</span>";
    try {
      dispatch(changeLoading(true));
      const response = await axios.post(
        "https://api.openai.com/v1/chat/completions",
        {
          model: "gpt-3.5-turbo", // "gpt-3.5-turbo" - cheaper option
          messages: [{ role: "user", content: question }],
          max_tokens: 300,
        },
        {
          headers: {
            Authorization: `Bearer ${apiKey}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (
        response.data &&
        response.data.choices &&
        response.data.choices.length > 0
      ) {
        // const answer = response.data.choices[0].message.content;
        const answer = `${messageText}\n${response.data.choices[0].message.content}`;
        setAnswer(answer); // Set the answer from OpenAI
        setOpen(true); // Open the Popover
      } else {
        setAnswer("No answer received"); // Handle case where there's no answer in the response
        setOpen(true); // Open the Popover
      }
      dispatch(changeLoading(false)); // Set loading to false after receiving the response
    } catch (error) {
      console.error("Error fetching answer from OpenAI:", error);
      setAnswer("Error fetching answer");
      setOpen(true); // Open the Popover
      dispatch(changeLoading(false)); // Set loading to false in case of error
    }
  };

  return isMobile ? (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        overflow: "auto",
        padding: "4px",
        paddingTop: 0,
        height: "calc(100vh - 130px)",
        position: "relative",
      }}
    >
      {currentResults
        .filter(
          (result) => result.Profil?.length > 0 || result.Profil === undefined
        )
        .map((group, groupIndex) => (
          <Box key={groupIndex} sx={{ marginBottom: "10px" }}>
            {/* TechGroupName as a separate row */}
            <Box
              sx={{
                fontWeight: "bold",
                backgroundColor: "silver",
                padding: "2px",
                borderRadius: "5px",
                fontSize: "15px",
              }}
            >
              {group.TechGroupName || ""}
            </Box>

            {/* Results for each group */}
            {group.Result.map((result, resultIndex) => (
              <Box
                key={resultIndex}
                sx={{
                  display: "flex",
                  fontSize: "15px",
                  flexDirection: "column",
                  padding: "2px",
                  borderBottom: "1px solid #ddd",
                  backgroundColor: "#fff",
                  borderRadius: "5px",
                  marginTop: "4px",
                  boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
                }}
              >
                {/* First row: NameTest, Показател (with icon), Resultat, Ucum */}
                {/* NameTest */}
                <Box sx={{ flex: 1, fontWeight: "bold", fontSize: "12px" }}>
                  {result.NameTest || ""}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {/* Показател (Indicator) with Icon */}
                  <Box sx={{ flex: 1, textAlign: "center" }}>
                    {result.Profil &&
                      result.Profil.length === 0 &&
                      result.RangeState === 2 && (
                        <Tooltip title="Ниска стойност" arrow placement="top">
                          <SouthIcon
                            sx={{ color: "orange", verticalAlign: "middle" }}
                          />
                        </Tooltip>
                      )}
                    {result.Profil &&
                      result.Profil.length === 0 &&
                      result.RangeState === 3 && (
                        <Tooltip title="Висока стойност" arrow placement="top">
                          <NorthIcon
                            sx={{ color: "red", verticalAlign: "middle" }}
                          />
                        </Tooltip>
                      )}
                  </Box>

                  {/* Resultat */}
                  <Box
                    sx={{
                      flex: 1,
                      textAlign: "right",
                    }}
                  >
                    {result.Resultat || ""}
                  </Box>

                  {/* Ucum */}
                  <Box
                    sx={{
                      flex: 1,
                      textAlign: "right",
                      fontSize: "12px",
                      paddingRight: "5px",
                    }}
                  >
                    {result.Ucum || ""}
                  </Box>
                </Box>

                {/* Second row: ReferenceValue */}
                <Box sx={{ display: "flex", flex: 1, whiteSpace: "nowrap" }}>
                  {result.ReferenceValue && (
                    <Box
                      sx={{
                        textAlign: "left",
                        fontSize: "12px",
                        color: "gray",
                        marginTop: "4px",
                        fontStyle: "italic",
                        whiteSpace: "wrap",
                        marginRight: "5px",
                      }}
                    >
                      {result.ReferenceValue}
                    </Box>
                  )}
                  <Box
                    sx={{
                      backgroundColor: "#fff",
                      justifyContent: "flex-end",
                      display: "flex",
                      padding: "0px !important",
                    }}
                  >
                    {(result.TimeLine !== 0 && (
                      <IconButton
                        sx={{
                          padding: "0px",
                          marginLeft: "5px",
                          marginRight: "5px",
                          // textAlign: "right",
                        }}
                        onClick={(event) => {
                          event.stopPropagation();
                          handleChartFetch(groupIndex, resultIndex);
                        }}
                      >
                        <TimelineTwoToneIcon
                          sx={{
                            // padding: "0px",
                            cursor: "pointer",
                            color: "blue",
                          }}
                        />
                      </IconButton>
                    )) ||
                      ""}
                  </Box>
                  <Box>
                    <TableCell
                      sx={{
                        padding: "0px",
                        backgroundColor: "#fff",
                      }}
                    >
                      {config.ApiKey.length > 0 &&
                        result.Resultat &&
                        result.ReferenceValue && (
                          <IconButton
                            onClick={(event) => {
                              event.stopPropagation();
                              handlePopoverOpen(event, groupIndex, resultIndex);
                            }}
                          >
                            <QuestionAnswerIcon
                              sx={{
                                cursor: "pointer",
                                color: "blue",
                              }}
                            />
                          </IconButton>
                        )}
                      <Popover
                        open={open}
                        onClose={handlePopoverClose}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                          vertical: "center",
                          horizontal: "center",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center",
                        }}
                        sx={{
                          zIndex: 99999,
                          overflow: "auto",
                        }}
                      >
                        <Box
                          sx={{
                            position: "relative",
                            padding: 2,
                            minWidth: "250px",
                            bgcolor: "white",
                            borderRadius: "8px",
                            //boxShadow: 3,
                            //border: "2px solid red", // Debug border to check if Box is visible
                          }}
                        >
                          <IconButton
                            onClick={handlePopoverClose}
                            sx={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              color: "black",
                              //backgroundColor: "yellow", // Make it very visible
                              zIndex: 99999,
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>

                          <Typography sx={{ paddingTop: 2 }}>
                            <div dangerouslySetInnerHTML={{ __html: answer }} />
                            {/* {answer} */}
                          </Typography>
                        </Box>
                      </Popover>
                    </TableCell>
                  </Box>
                </Box>
                {selectedRow?.groupIndex === groupIndex &&
                  selectedRow?.resultIndex === resultIndex &&
                  chartData !== null &&
                  chartData !== undefined && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        bgcolor: "white",
                        // p: 2,
                        borderRadius: 2,
                        boxShadow: 3,
                      }}
                    >
                      <Chart chartData={chartData} />
                    </Box>
                  )}
                {/* Profil (if available) */}
                {result.Profil && result.Profil.length > 0 && (
                  <Box sx={{ marginLeft: "20px", marginTop: "6px" }}>
                    {result.Profil.map((profilItem, profilIndex) => (
                      <Box key={profilIndex}>
                        {/* Profil NameTest */}
                        <Box sx={{ flex: 1, fontSize: "12px" }}>
                          {profilItem.ProfilNameTest || ""}
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "4px",
                            backgroundColor: "#fff",
                            borderRadius: "4px",
                            marginBottom: "3px",
                          }}
                        >
                          {/* Profil Показател (Indicator) with Icon */}
                          <Box sx={{ flex: 1, textAlign: "center" }}>
                            {profilItem.ProfilRangeState === 2 && (
                              <Tooltip
                                title="Ниска стойност"
                                arrow
                                placement="top"
                              >
                                <SouthIcon
                                  sx={{
                                    color: "orange",
                                    verticalAlign: "middle",
                                  }}
                                />
                              </Tooltip>
                            )}
                            {profilItem.ProfilRangeState === 3 && (
                              <Tooltip
                                title="Висока стойност"
                                arrow
                                placement="top"
                              >
                                <NorthIcon
                                  sx={{ color: "red", verticalAlign: "middle" }}
                                />
                              </Tooltip>
                            )}
                          </Box>

                          {/* Profil Result */}
                          <Box sx={{ flex: 1, textAlign: "right" }}>
                            {profilItem.ProfilResultat || ""}
                          </Box>

                          {/* Profil Ucum */}
                          <Box
                            sx={{
                              flex: 1,
                              textAlign: "right",
                              fontSize: "12px",
                              paddingRight: "5px",
                            }}
                          >
                            {profilItem.ProfilUcum || ""}
                          </Box>
                        </Box>

                        {/* Profil Reference Value (Fixed Placement) */}
                        {profilItem.ProfilReferenceValue && (
                          <Box
                            sx={{
                              textAlign: "left",
                              fontSize: "12px",
                              color: "gray",
                              marginTop: "4px",
                              fontStyle: "italic",
                            }}
                          >
                            <Box sx={{ flexGrow: 1 }}>
                              {profilItem.ProfilReferenceValue}

                              {profilItem.TimeLine !== 0 && (
                                <IconButton
                                  size="small"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    handleChartFetch(
                                      groupIndex,
                                      resultIndex,
                                      profilIndex
                                    );
                                  }}
                                >
                                  <TimelineTwoToneIcon
                                    sx={{
                                      cursor: "pointer",
                                      color: "blue",
                                    }}
                                  />
                                </IconButton>
                              )}
                              {config.ApiKey.length > 0 && (
                                <IconButton
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    handlePopoverOpen(
                                      event,
                                      groupIndex,
                                      resultIndex,
                                      profilIndex
                                    );
                                  }}
                                >
                                  <QuestionAnswerIcon
                                    sx={{
                                      cursor: "pointer",
                                      color: "blue",
                                    }}
                                  />
                                </IconButton>
                              )}
                            </Box>
                            <Popover
                              open={open}
                              onClose={handlePopoverClose}
                              anchorEl={anchorEl} // Anchor to the button or icon
                              anchorOrigin={{
                                vertical: "center", // Adjust as needed
                                horizontal: "center",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "center",
                              }}
                              sx={{
                                zIndex: 99999,
                                overflow: "auto",
                              }}
                            >
                              <Box
                                sx={{
                                  position: "relative",
                                  padding: 2,
                                  minWidth: "250px",
                                  bgcolor: "white",
                                  borderRadius: "8px",
                                  //boxShadow: 3,
                                  //border: "2px solid red", // Debug border to check if Box is visible
                                }}
                              >
                                <IconButton
                                  onClick={handlePopoverClose}
                                  sx={{
                                    position: "absolute",
                                    top: 8,
                                    right: 8,
                                    color: "black",
                                    //backgroundColor: "yellow", // Make it very visible
                                    zIndex: 99999,
                                  }}
                                >
                                  <CloseIcon fontSize="small" />
                                </IconButton>

                                <Typography sx={{ paddingTop: 2 }}>
                                  <div
                                    dangerouslySetInnerHTML={{ __html: answer }}
                                  />
                                  {/* {answer} */}
                                </Typography>
                              </Box>
                            </Popover>
                          </Box>
                        )}

                        {selectedProfilRow?.uniqueId ===
                          `${groupIndex}-${resultIndex}-${profilIndex}` &&
                          chartData !== null &&
                          chartData !== undefined && (
                            <TableRow>
                              <TableCell colSpan={6}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    bgcolor: "white",
                                    borderRadius: 2,
                                    boxShadow: 3,
                                  }}
                                >
                                  <Chart chartData={chartData} />
                                </Box>
                              </TableCell>
                            </TableRow>
                          )}
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            ))}
          </Box>
        ))}
    </Box>
  ) : (
    <Box
      className="table-box"
      sx={{
        display: "flex",
        marginLeft: "10%",
        justifyContent: "center",
        width: "80%",
        height: "calc(100vh - 150px)",
        overflow: "auto",
        position: "relative",
        marginBottom: "5vh",
      }}
    >
      <TableContainer
        component={Paper}
        sx={{
          width: "80%",
          maxHeight: "calc(100vh - 50px - 35px)",
          flexGrow: 1,
          overflow: "auto",
          "&::-webkit-scrollbar": { display: "none" },
          boxShadow: 3,
          borderRadius: 2,
        }}
      >
        <Table
          stickyHeader
          aria-label="results table"
          sx={{
            "& tbody tr:nth-of-type(odd)": {
              backgroundColor: "#f6f6f8",
            },
            "& tbody tr:hover": {
              outline: `2px solid ${config.footerBarColor}`,
              cursor: "pointer",
              outlineOffset: "-2px",
              boxShadow: "0 0 10px rgba(0, 81, 177, 0.3)",
              borderRadius: "8px",
            },
          }}
        >
          <TableHead
            sx={{
              "& .MuiTableCell-head": {
                backgroundColor: "gray",
              },
            }}
          >
            {/* Table headers for the columns NameTest, Resultat, Ucum, ReferenceValue */}
            <TableRow sx={{ backgroundColor: "white", height: "30px" }}>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  padding: "8px",
                  whiteSpace: "nowrap",
                }}
              >
                Име на теста (изследване)
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  padding: "8px",
                  whiteSpace: "nowrap",
                }}
              ></TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  padding: "8px",
                  whiteSpace: "nowrap",
                  textAlign: "right",
                }}
              >
                Резултат
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  padding: "8px",
                  whiteSpace: "nowrap",
                }}
              >
                Единици
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  padding: "8px",
                  whiteSpace: "nowrap",
                }}
              >
                Референтни стойности
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  padding: "8px",
                  whiteSpace: "nowrap",
                }}
              >
                Графика
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  padding: "8px",
                  whiteSpace: "nowrap",
                }}
              >
                AI
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {currentResults
              .filter(
                (result) =>
                  result.Profil?.length > 0 || result.Profil === undefined
              )
              .map((group, groupIndex) => (
                <React.Fragment key={groupIndex}>
                  {/* Display TechGroupName for each group */}
                  <TableRow
                    sx={{
                      height: "25px",
                      "& .MuiTableCell-root": {
                        backgroundColor: "lightgray",
                      },
                    }}
                  >
                    <TableCell
                      colSpan={4}
                      sx={{
                        fontWeight: "bold",
                        backgroundColor: "#f6f6f8",
                        // textAlign: "center",
                        padding: "4px",
                        textAlign: "left",
                      }}
                    >
                      {group.TechGroupName || ""}
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "#f6f6f8",
                      }}
                    >
                      {""}
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "#f6f6f8",
                      }}
                    >
                      {""}
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "#f6f6f8",
                      }}
                    >
                      {""}
                    </TableCell>
                  </TableRow>
                  {/* Results Rows for each result */}
                  {group.Result.map((result, resultIndex) => (
                    <React.Fragment key={resultIndex}>
                      <TableRow
                        sx={{
                          height: "10px",
                          padding: "0 !important",
                          backgroundColor: "white !important",
                          "& .MuiTableCell-root": {
                            height: "10px",
                            padding: 0,
                          },
                        }}
                      >
                        <TableCell sx={{ height: "10px", padding: "4px" }}>
                          {result.NameTest || ""}
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            height: "10px",
                            "& .MuiTableCell-root": {
                              height: "10px",
                              padding: 0,
                            },
                          }}
                        >
                          {result.Profil &&
                            result.Profil.length === 0 &&
                            result.RangeState === 2 && (
                              <Tooltip
                                title="Ниска стойност"
                                arrow
                                placement="top"
                              >
                                <SouthIcon
                                  sx={{
                                    color: "orange",
                                    marginRight: "8px",
                                    verticalAlign: "middle",
                                  }}
                                />
                              </Tooltip>
                            )}
                          {result.Profil &&
                            result.Profil.length === 0 &&
                            result.RangeState === 3 && (
                              <Tooltip
                                title="Висока стойност"
                                arrow
                                placement="top"
                              >
                                <NorthIcon
                                  sx={{
                                    color: "red",
                                    marginRight: "8px",
                                    verticalAlign: "middle",
                                  }}
                                />
                              </Tooltip>
                            )}
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "wrap",
                            height: "10px",
                            padding: "4px",
                            textAlign: "right",
                            "& .MuiTableCell-root": {
                              height: "10px",
                              padding: 0,
                            },
                          }}
                        >
                          {result.Resultat || ""}
                        </TableCell>
                        <TableCell
                          sx={{
                            textIndent: "10px",
                          }}
                        >
                          {result.Ucum || ""}
                        </TableCell>
                        <TableCell>{result.ReferenceValue || ""}</TableCell>
                        <TableCell
                          sx={{
                            backgroundColor: "#fff",
                          }}
                        >
                          {(result.TimeLine !== 0 && (
                            <IconButton
                              onClick={(event) => {
                                event.stopPropagation();
                                handleChartFetch(groupIndex, resultIndex);
                              }}
                            >
                              <TimelineTwoToneIcon
                                sx={{
                                  cursor: "pointer",
                                  color: "blue",
                                }}
                              />
                            </IconButton>
                          )) ||
                            ""}
                        </TableCell>
                        <TableCell
                          sx={{
                            backgroundColor: "#fff",
                          }}
                        >
                          {config.ApiKey.length > 0 &&
                            result.Resultat &&
                            result.ReferenceValue && (
                              <IconButton
                                onClick={(event) => {
                                  event.stopPropagation();
                                  handlePopoverOpen(
                                    event,
                                    groupIndex,
                                    resultIndex
                                  );
                                }}
                              >
                                <QuestionAnswerIcon
                                  sx={{
                                    cursor: "pointer",
                                    color: "blue",
                                  }}
                                />
                              </IconButton>
                            )}

                          <Popover
                            open={open}
                            onClose={handlePopoverClose}
                            anchorEl={anchorEl} // Anchor to the button or icon
                            anchorOrigin={{
                              vertical: "center", // Adjust as needed
                              horizontal: "center",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "center",
                            }}
                            sx={{
                              zIndex: 99999,
                              overflow: "auto",
                            }}
                          >
                            <Box
                              sx={{
                                position: "relative",
                                padding: 2,
                                minWidth: "250px",
                                bgcolor: "white",
                                borderRadius: "8px",
                                //boxShadow: 3,
                                //border: "2px solid red", // Debug border to check if Box is visible
                              }}
                            >
                              <IconButton
                                onClick={handlePopoverClose}
                                sx={{
                                  position: "absolute",
                                  top: 8,
                                  right: 8,
                                  color: "black",
                                  //backgroundColor: "yellow", // Make it very visible
                                  zIndex: 99999,
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>

                              <Typography sx={{ paddingTop: 2 }}>
                                <div
                                  dangerouslySetInnerHTML={{ __html: answer }}
                                />
                              </Typography>
                            </Box>
                          </Popover>
                        </TableCell>
                      </TableRow>
                      {selectedRow?.groupIndex === groupIndex &&
                        selectedRow?.resultIndex === resultIndex &&
                        chartData !== null &&
                        chartData !== undefined && (
                          <TableRow
                            style={{
                              overflow: "visible",
                              position: "relative",
                            }}
                          >
                            <TableCell
                              colSpan={6}
                              style={{
                                overflow: "visible",
                                position: "relative",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  bgcolor: "white",
                                  p: 2,
                                  borderRadius: 2,
                                  boxShadow: 3,
                                  overflow: "visible",
                                }}
                              >
                                <div
                                  style={{
                                    position: "relative",
                                    zIndex: 9999,
                                  }}
                                >
                                  <Chart
                                    key={chartData?.id || "chart"}
                                    chartData={chartData}
                                  />
                                </div>
                              </Box>
                            </TableCell>
                          </TableRow>
                        )}
                      {/* Render Profil if not empty */}
                      {result.Profil && result.Profil.length > 0 && (
                        <>
                          {/* Profil Data */}

                          {result.Profil.map((profilItem, profilIndex) => (
                            <React.Fragment
                              key={`${resultIndex}-${profilIndex}`}
                            >
                              <TableRow
                                sx={{
                                  height: "10px",
                                  "& .MuiTableCell-root": {
                                    height: "10px",
                                    padding: 0,
                                    backgroundColor: "white !important",
                                  },
                                }}
                              >
                                <TableCell
                                  sx={{
                                    paddingLeft: "32px !important",
                                    lineHeight: "1.2",
                                    height: "10px",
                                    backgroundColor: "white !important",
                                  }}
                                >
                                  {profilItem.ProfilNameTest || ""}
                                </TableCell>
                                <TableCell>
                                  {profilItem.ProfilRangeState === 2 && (
                                    <Tooltip
                                      title="Ниска стойност"
                                      arrow
                                      placement="top"
                                    >
                                      <SouthIcon
                                        sx={{
                                          color: "orange",
                                          marginRight: "8px",
                                          verticalAlign: "middle",
                                        }}
                                      />
                                    </Tooltip>
                                  )}
                                  {profilItem.ProfilRangeState === 3 && (
                                    <Tooltip
                                      title="Висока стойност"
                                      arrow
                                      placement="top"
                                    >
                                      <NorthIcon
                                        sx={{
                                          color: "red",
                                          marginRight: "8px",
                                          verticalAlign: "middle",
                                        }}
                                      />
                                    </Tooltip>
                                  )}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    whiteSpace: "nowrap",
                                    textAlign: "right",
                                  }}
                                >
                                  {profilItem.ProfilResultat || ""}
                                </TableCell>
                                <TableCell sx={{ textIndent: "10px" }}>
                                  {profilItem.ProfilUcum || ""}
                                </TableCell>
                                <TableCell>
                                  {profilItem.ProfilReferenceValue || ""}
                                </TableCell>
                                <TableCell sx={{ backgroundColor: "#fff" }}>
                                  {profilItem.TimeLine !== 0 && (
                                    <IconButton
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        handleChartFetch(
                                          groupIndex,
                                          resultIndex,
                                          profilIndex
                                        );
                                      }}
                                    >
                                      <TimelineTwoToneIcon
                                        sx={{
                                          cursor: "pointer",
                                          color: "blue",
                                        }}
                                      />
                                    </IconButton>
                                  )}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    backgroundColor: "#fff",
                                  }}
                                >
                                  {config.ApiKey.length > 0 && (
                                    <IconButton
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        handlePopoverOpen(
                                          event,
                                          groupIndex,
                                          resultIndex,
                                          profilIndex
                                        );
                                      }}
                                    >
                                      <QuestionAnswerIcon
                                        sx={{
                                          cursor: "pointer",
                                          color: "blue",
                                        }}
                                      />
                                    </IconButton>
                                  )}
                                  <Popover
                                    open={open}
                                    onClose={handlePopoverClose}
                                    anchorEl={anchorEl} // Anchor to the button or icon
                                    anchorOrigin={{
                                      vertical: "center", // Adjust as needed
                                      horizontal: "center",
                                    }}
                                    transformOrigin={{
                                      vertical: "top",
                                      horizontal: "center",
                                    }}
                                    sx={{
                                      zIndex: 99999,
                                      overflow: "auto",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        position: "relative",
                                        padding: 2,
                                        minWidth: "250px",
                                        bgcolor: "white",
                                        borderRadius: "8px",
                                        //boxShadow: 3,
                                        //border: "2px solid red", // Debug border to check if Box is visible
                                      }}
                                    >
                                      <IconButton
                                        onClick={handlePopoverClose}
                                        sx={{
                                          position: "absolute",
                                          top: 8,
                                          right: 8,
                                          color: "black",
                                          //backgroundColor: "yellow", // Make it very visible
                                          zIndex: 99999,
                                        }}
                                      >
                                        <CloseIcon fontSize="small" />
                                      </IconButton>

                                      <Typography sx={{ paddingTop: 2 }}>
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: answer,
                                          }}
                                        />
                                        {/* {answer} */}
                                      </Typography>
                                    </Box>
                                  </Popover>
                                </TableCell>
                              </TableRow>

                              {/* ✅ Expand Profil Chart only for the clicked profil row */}
                              {selectedProfilRow?.uniqueId ===
                                `${groupIndex}-${resultIndex}-${profilIndex}` &&
                                chartData !== null &&
                                chartData !== undefined && (
                                  <TableRow>
                                    <TableCell colSpan={6}>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          justifyContent: "center",
                                          bgcolor: "white",
                                          p: 2,
                                          borderRadius: 2,
                                          boxShadow: 3,
                                        }}
                                      >
                                        <Chart chartData={chartData} />
                                      </Box>
                                    </TableCell>
                                  </TableRow>
                                )}
                            </React.Fragment>
                          ))}
                        </>
                      )}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={currentResults?.length || 0}
          // count={results?.length || 0}// Общ брой резултати
          page={currentPage}
          onPageChange={handlePageChange} // Смяна на страницата
          rowsPerPage={resultsPerPage}
          onRowsPerPageChange={handleResultsPerPageChange}
          rowsPerPageOptions={[5, 10, 15, 20, 50, 100]}
          labelRowsPerPage="Покажи"
          labelDisplayedRows={() => null} // Скриване на стандартния текст "Страница X от Y"
          slotProps={{
            select: {
              inputProps: {
                "aria-label": "rows per page",
                id: "rows-per-page-select",
                name: "rows-per-page",
              },
            },
          }}
          sx={{
            background: "#F6F6F8",
            borderTop: "1px solid rgba(224, 224, 224, 1)",
            position: "sticky",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "40px", // Adjusts overall row height
            minHeight: "unset", // Removes default minimum height
            "& .MuiTablePagination-root": {
              "& .MuiPaper-root": {
                left: "auto !important",
              },
            },
            "& .MuiTablePagination-toolbar": {
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              padding: "0 8px", // Reduces padding in pagination toolbar
              minHeight: "unset", // Removes any minimum height restriction
            },
            "& .MuiTablePagination-caption, & .MuiTablePagination-selectLabel":
              {
                margin: "0 10px",
                fontSize: "0.75rem", // Reduces font size of labels
                padding: "0 4px", // Adjusts padding
              },
            "& .MuiTablePagination-actions": {
              display: "flex",
              justifyContent: "flex-end",
              order: 2,
            },
            "& .MuiToolbar-root": {
              justifyContent: "center",
            },
            "& .MuiTablePagination-spacer": {
              flex: "0 0 auto",
            },
            "& .MuiSelect-root": {
              marginRight: "5px", //  dropdown spacing
            },
          }}
          // Къстъмизация на бутоните за страници
          ActionsComponent={({ count, page, rowsPerPage, onPageChange }) => (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <IconButton
                onClick={(event) => onPageChange(event, page - 1)}
                disabled={page === 0}
                aria-label="Предишна страница"
              >
                <KeyboardArrowLeftIcon />
              </IconButton>
              <Typography variant="body2" sx={{ margin: "0 10px" }}>
                {page + 1} / {Math.max(1, Math.ceil(count / rowsPerPage))}
              </Typography>
              <IconButton
                onClick={(event) => onPageChange(event, page + 1)} // Следваща страница
                disabled={
                  page >= Math.max(1, Math.ceil(count / rowsPerPage)) - 1
                }
                aria-label="Следваща страница"
              >
                <KeyboardArrowRightIcon />
              </IconButton>
            </Box>
          )}
        />
      </TableContainer>
      <Modal open={openChart} onClose={() => setOpenChart(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            bgcolor: "white",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
          }}
        >
          {/*<Chart data={selectedResult} />  Pass data if needed */}
          <Chart /> {/* Pass data if needed */}
        </Box>
      </Modal>
    </Box>
  );
}
